__turbopack_context__.v({
  "item": "cXzzpa_item",
  "itemDate": "cXzzpa_itemDate",
  "labelWrapper": "cXzzpa_labelWrapper",
  "roomTitle": "cXzzpa_roomTitle",
  "roomTitleWrapper": "cXzzpa_roomTitleWrapper",
  "subLabel": "cXzzpa_subLabel",
  "wrapper": "cXzzpa_wrapper",
});
